import Model from "@/app/models/Concerns/Model";

export default class ProductType extends Model {
    name!: string;

    getTable(): string {
        return "product-types";
    }
}